module.exports = __webpack_public_path__ + "img/frame (24).9a3c8ed5.jpg";